// export default {
//     name: 'QAvatar',
//     props: {
//         src: {
//             type: String,
//             default: ''
//         },
//         name: {
//             type: String,
//             default: ''
//         },
//         jobTitle: {
//             type: String,
//             default: ''
//         },
//         date: {
//             type: [String, Date],
//             default: ''
//         },
//         text: {
//             type: String,
//             default: ''
//         },
//         size: {
//             type: String,
//             default: 'is-small'
//         }
//     },
//     computed: {
//         hasTextContent() {
//             return this.name || this.jobTitle || this.date || this.text;
//         }
//     }
// };

export const AVATAR_COLORS = [
    'maroon-40',
    'purple-40',
    'pink-30',
    'red-40',
    'gray-10',
    'orange-40',
    'teal-30',
    'green-40',
];

export default {
    name: 'QAvatar',
    props: {
        size: {
            type: String,
            default: 'sm',
        },
        color: {
            type: String,
            default: 'gray-10',
        },
        src: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        userId: {
            type: [String, Number],
            default: '',
        },
        onDuty: {
            type: Boolean,
            default: false,
        },
        ring: {
            type: Boolean,
            default: true,
        },
        width: {
            type: String,
            default: '',
        },
        height: {
            type: String,
            default: '',
        },
        hasAction: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            validSrc: true,
        };
    },
    methods: {
        getRandomColor() {
            const colorIndex = Math.floor(Math.random() * AVATAR_COLORS.length);
            return AVATAR_COLORS[colorIndex];
        },
    },
    computed: {
        userColor() {
            // If a User ID was passed to the Avatar.
            if (this.src && this.validSrc) {
                return 'white';
            }

            if (this.userId) {
                let avatarColors = [];
                let randomColor = '';

                // If local storage variable for colors.
                if (window.localStorage.getItem('user-colors')) {
                    // Apply colors to variable and parse.
                    avatarColors = JSON.parse(
                        window.localStorage.getItem('user-colors')
                    );
                }

                // Loop through colors and compare user IDs.
                avatarColors.forEach((avatarColor) => {
                    if (this.userId === avatarColor.id) {
                        // Set color if user has one.
                        randomColor = avatarColor.color;
                    }
                });

                // If color is set from local storage.
                if (randomColor) {
                    return randomColor;
                } else {
                    // Else, get a random color from the array.
                    randomColor = this.getRandomColor();

                    // Push to the colors object.
                    avatarColors.push({
                        id: this.userId,
                        color: randomColor,
                    });

                    // Set local storage to updated object.
                    window.localStorage.setItem(
                        'user-colors',
                        JSON.stringify(avatarColors)
                    );

                    // Set color for avatar.
                    return randomColor;
                }
            } else {
                return this.color;
            }
        },
    },
};
